import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String }

  copy(event) {
    event.preventDefault()

    navigator.clipboard.writeText(this.textValue)
      .then(() => {
        // Optional: Add feedback like a tooltip or flash message
        this.element.classList.add("copied")

        // Remove the feedback class after a delay
        setTimeout(() => {
          this.element.classList.remove("copied")
        }, 2000)
      })
      .catch(err => {
        console.error('Failed to copy text: ', err)
      })
  }
}
